import React from 'react'

function Footer() {
  return (
    <div className='footer'>
      <p>&copy; Amr Elmansoury {new Date().getFullYear()}</p>
    </div>
  )
}

export default Footer;
